import * as themes from '@theme-ui/presets'

export default themes as any
